<template>
  <div class="js-accordion" v-cloak>
    <button
      class="js-accordion--trigger"
      type="button btn-primary"
      @click="accordionToggle()"
      :class="{ '_state-open': isOpened }"
    >
      <slot name="title"></slot>
    </button>
    <div class="js-accordion--target small text-dark" :class="{ '_state-open': isOpened }" v-if="isOpened">
      <slot name="body"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "Accordion",
  props: [
    "opened"
  ],
  components: {},
  created:function(){
    this.isOpened = this.opened
  },
  methods: {
    accordionToggle: function() {
      this.isOpened = !this.isOpened;
    }
  },
  data: function() {
    return {
      isOpened: false
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.js-accordion:last-child {
  border-bottom-width: 1px;
}
.js-accordion--target {
  overflow: hidden;
  transition: 0.4s ease-in-out;
}
.js-accordion--body {
  /*padding: 30px;*/
}
.js-accordion {
  
  /* background-color: rgb(132,135,133); */

  /* border-color: #666; */
  /* border-style: solid; */
}

.js-accordion._state-open {
  /* background-color: #999; */
  text-decoration: none;
}
.js-accordion._state-open:after {
  transform: rotateX(180deg);
  margin-top: -10px;
}
.js-accordion--trigger:hover {
  /* background-color: #999; */
  text-decoration: none;
}
.js-accordion--trigger {
  position: relative;
  display: block;
  /* background-color: rgb(68, 68, 68); */
  width: 100%;
  transition: all 0.2s ease-in;
  color: black;
  display: block;
  font-size: 15px;
  /* font-weight: bold; */
  text-align: center;
  outline: none;
  border: none;
  cursor: pointer;
  height:36px;
  background-color: white;
}
</style>
